import { CSSProperties, ReactNode, useMemo, forwardRef } from "react";
import { cn } from "../../../utils";
import { Typography } from "../Typography";

type TCardProps = {
  title?: string | ReactNode;
  children: ReactNode;
  className?: string;
  classNameContent?: string;
  titleClassName?: string;
  isTitleString?: boolean; // If true, title is a string, otherwise it can be any ReactNode
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  id?: string;
  style?: CSSProperties;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  dataTestId?: string;
};

const CommonCardUI = forwardRef<HTMLDivElement, TCardProps>(
  (
    {
      title = "",
      children,
      className = "",
      classNameContent = "",
      titleClassName = "",
      isTitleString = true,
      onClick = () => null,
      id = "",
      style,
      onMouseEnter,
      onMouseLeave,
      dataTestId,
    },
    ref,
  ) => {
    const content = useMemo(() => {
      return (
        <>
          {title && isTitleString && (
            <Typography
              variant={"h6"}
              className={cn("mb-2 text-secondary", titleClassName)}
            >
              {title}
            </Typography>
          )}
          {title && !isTitleString && <>{title}</>}
          {children}
        </>
      );
    }, [children, title, titleClassName, isTitleString]);

    return (
      <div
        data-testid={dataTestId}
        className={cn(
          "rounded-lg border dark:bg-white/5 dark:border-white/10 relative",
          className,
        )}
        ref={ref}
        style={style}
        onClick={onClick}
        id={id}
        onMouseLeave={onMouseLeave}
        onMouseEnter={onMouseEnter}
      >
        <div
          className={cn("px-3 py-3", classNameContent)}
          data-testid="common-card-content"
        >
          {content}
        </div>
      </div>
    );
  },
);

CommonCardUI.displayName = "CommonCardUI";

export default CommonCardUI;
